import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { SpinnerService } from '../../../services/spinner.service'

@Component({
  selector: 'app-spinner',
  imports: [MatProgressSpinnerModule],
  templateUrl: './spinner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './spinner.component.scss',
})
export class SpinnerComponent {
  spinnerService = inject(SpinnerService)
}
